import React from 'react'
import CastCrewCard from '../castcrewCard/CastCrewCard'

function Crew({crew}) {
        return (
           <CastCrewCard item={crew}></CastCrewCard>
          )
}

export default Crew